import styled from 'styled-components';
import { Descriptions as DescriptionsAnt } from 'antd';

export const DescriptionsHeader = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 16px 20px 8px;
`;

export const DescriptionsContainer = styled.div<{ borderless?: boolean }>`
	border: ${p => (p.borderless ? 'none' : `1px solid ${p.theme.border}`)};
	border-radius: 6px;
	padding-bottom: 8px;
	margin: 0 auto;

	${DescriptionsHeader} {
		padding: ${p => (p.borderless ? '4px 20px 8px ' : '16px 20px 8px')};
	}
`;

export const DescriptionsActions = styled.div`
	display: flex;
	gap: 2px;
`;

export const Descriptions = styled(DescriptionsAnt)`
	.ant-descriptions-view {
		border: none !important;
	}

	.ant-descriptions-item-label {
		background-color: transparent !important;
		border-inline-end: none !important;
		padding: 12px 16px;
	}

	.ant-descriptions-item-content {
		padding: 8px 16px !important;
		border-inline-end: none !important;
		color: ${p => p.theme.text} !important;
	}
`;
